import { Component, ElementRef, Inject, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {createWidget, Widget} from '@typeform/embed'
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import {ConfigService} from "../../common/service/config.service";
import {mergeMap, tap, timer} from "rxjs";

@Component({
  selector: 'app-form',
  standalone: true,
  imports: [],
  templateUrl: './form.component.html'
})
export class FormComponent implements OnInit, OnDestroy {
  @ViewChild('container', { static: true }) container!: ElementRef<HTMLDivElement>;
  private widget?: Widget;
  private config: any;
  private jobId: string | undefined;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private configService: ConfigService,
    private ngZone: NgZone,
    @Inject('Storage') protected storage: Storage
  ) {}

  ngOnInit() {

    const params = JSON.parse(this.storage.getItem('utm_params') || '{}');
    // console.log('UTM params from storage:', params);

    if ( ! window.location.search && params) {
      const retrievedParams = new URLSearchParams(params);
      if(window.location.search != retrievedParams.toString()) {
        window.location.search = retrievedParams.toString();
      }
    }

    this.configService.config$.pipe(
      tap(config => this.config = config),
      mergeMap(() => this.route.params),
      tap(params => this.jobId = params['jobId']),
    ).subscribe(()=> {

      this.widget = createWidget(this.config.contentBlocks.typeform.content, {
        container: this.container.nativeElement,
        inlineOnMobile: true,
        transitiveSearchParams: true,             // keep ?utm_… params
        onReady: () => console.log('Typeform ready'),
        onSubmit: () => {
          console.log('Typeform submitted');

          timer(5000).subscribe(() => {
            window.location.href = window.location.href.replace('form', 'result');
          });
        },
        onQuestionChanged: (e) => console.log('Question index', e),
      });
    });

  }

  ngOnDestroy() {
    this.widget?.unmount();
  }
}
